import React from 'react';
import $ from 'jquery';

require('bootstrap');

const links = [
    {href: 'about', text: 'About'},
    {href: 'services', text: 'Services'},
    {href: 'contact', text: 'Contact'},
    {href: 'join-us', text: 'Join Us'}
];

class Navbar extends React.Component {

    constructor(props) {
        super(props);

        // Closes responsive menu when a scroll trigger link is clicked
        $('.js-scroll-trigger').click(function () {
            $('.navbar-collapse').collapse('hide');
        });

        // Activate scrollspy to add active class to navbar items on scroll
        $('body').scrollspy({
            target: '#mainNav',
            offset: 105
        });
    }

    collapseNavbar() {
        // Collapse Navbar
        let mainNav = $('#mainNav');
        if (mainNav.offset().top > 105) {
            mainNav.addClass('navbar-shrink');
        } else {
            mainNav.removeClass('navbar-shrink');
        }
    }

    componentDidMount() {
        this.collapseNavbar();

        // Collapse the navbar when page is scrolled
        $(window).scroll(this.collapseNavbar);
    }

    render() {
        return (
            <nav className="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
                <div className="container">
                    <a className="navbar-brand js-scroll-trigger" href="#page-top">
                        <img src="../img/logo.png"/>
                    </a>
                    <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse"
                            data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false"
                            aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarResponsive">
                        <ul className="navbar-nav ml-auto">
                            {
                                links.map((link, index) => {
                                    return (
                                        <li className="nav-item" key={index}>
                                            <a className="nav-link js-scroll-trigger"
                                               href={`#${link.href}`}>{link.text}
                                            </a>
                                        </li>
                                    );
                                })
                            }
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}

export default Navbar;


// WEBPACK FOOTER //
// ./src/js/App/Navbar/Navbar.js